var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite_card"},[_vm._v(" [请前往成都购房通小程序查看，微信-发现-小程序-搜索“成都购房通”] ")])}
var staticRenderFns = []

export { render, staticRenderFns }